<c-card *transloco="let t">

  <c-card-body>

    <c-row class="mb-3">

      <c-col>

        <button cButton class="btn btn-light" routerLink="/mgmt/threats">

          <i class="fa-solid fa-arrow-left"></i> {{ t('Back') }}

        </button>

      </c-col>

    </c-row>



    <h1>{{ t('Create Alert Zone') }}</h1>

    <p class="text-muted">{{ t('Define a custom threat area with a geographic boundary or a pin with radius.') }}</p>



    <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()">

      <c-row>

        <c-col class="col-lg-6">

          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Shape') }}</label>

            <div class="col-sm-8">

              <div class="btn-group w-100" role="group">

                <button type="button" class="btn" [class.btn-info]="shapeMode === 'polygon'" [class.text-white]="shapeMode === 'polygon'" [class.btn-outline-secondary]="shapeMode !== 'polygon'" (click)="onShapeModeChange('polygon')">

                  {{ t('Polygon') }}

                </button>

                <button type="button" class="btn" [class.btn-info]="shapeMode === 'pin'" [class.text-white]="shapeMode === 'pin'" [class.btn-outline-secondary]="shapeMode !== 'pin'" (click)="onShapeModeChange('pin')">

                  {{ t('Pin') }}

                </button>

              </div>

            </div>

          </div>



          <div class="form-group row mb-2" *ngIf="shapeMode === 'pin'">

            <label class="col-sm-4 col-form-label text-end">{{ t('Radius (miles)') }}</label>

            <div class="col-sm-8 threat-radius-slider">

              <p class="radius-slider-value">{{ radiusMiles }} {{ t('miles') }}</p>

              <ngx-slider [(value)]="radiusMiles" [options]="radiusSliderOptions" (userChange)="onRadiusChange()"></ngx-slider>

              <small class="text-muted">{{ t('Workers within this distance of the pin are considered in the threat zone.') }}</small>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Title') }}</label>

            <div class="col-sm-8">

              <input cFormControl formControlName="headline" placeholder="{{ t('e.g. High crime risk area') }}" [ngClass]="{ 'border-danger': submitted && f['headline'].errors }" />

              <div *ngIf="submitted && f['headline'].errors?.['required']" class="invalid-feedback d-block">{{ t('Title is required') }}</div>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Severity') }}</label>

            <div class="col-sm-8">

              <select cSelect formControlName="severity">

                <option *ngFor="let sev of meta.severities" [value]="sev">{{ sev }}</option>

              </select>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Area Description') }}</label>

            <div class="col-sm-8">

              <input cFormControl formControlName="area_desc" placeholder="{{ t('e.g. Englewood, Chicago, IL 60621') }}" [ngClass]="{ 'border-danger': submitted && f['area_desc'].errors }" />

              <div *ngIf="submitted && f['area_desc'].errors?.['required']" class="invalid-feedback d-block">{{ t('Area description is required') }}</div>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Description') }}</label>

            <div class="col-sm-8">

              <textarea cFormControl formControlName="description" rows="4" placeholder="{{ t('e.g. Elevated risk of violent crime reported in this area, particularly after dark. Lone workers must not attend visits here after 8pm without prior manager approval. Stay aware of your surroundings, keep vehicle doors locked, and do not leave equipment visible in parked vehicles. Contact your supervisor immediately if you feel unsafe.') }}" [ngClass]="{ 'border-danger': submitted && f['description'].errors }"></textarea>

              <div *ngIf="submitted && f['description'].errors?.['required']" class="invalid-feedback d-block">{{ t('Description is required') }}</div>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Effective From') }}</label>

            <div class="col-sm-8">

              <input cFormControl type="date" formControlName="effective" />

              <small class="text-muted">{{ t('Leave blank to make this alert active immediately.') }}</small>

            </div>

          </div>



          <div class="form-group row mb-2">

            <label class="col-sm-4 col-form-label text-end">{{ t('Expires') }}</label>

            <div class="col-sm-8">

              <input cFormControl type="date" formControlName="expires" />

              <small class="text-muted">{{ t('Leave blank for no expiry.') }}</small>

            </div>

          </div>



          <button cButton class="btn btn-info  text-white w-100 py-2" type="submit">

            <i class="fa-solid fa-check"></i> {{ t('Save Alert Zone') }}

          </button>



        </c-col>



        <c-col class="col-lg-6">

          <label class="form-label">{{ shapeMode === 'pin' ? t('Pin location') : t('Boundary') }}</label>

          <p class="text-muted small" *ngIf="shapeMode === 'polygon'">{{ t('Use the polygon tool to draw the threat boundary on the map.') }}</p>

          <p class="text-muted small" *ngIf="shapeMode === 'pin'">{{ t('Use the point tool to place a pin on the map. The circle shows the alert radius.') }}</p>

          <div id="threat-draw-map"></div>

          <div *ngIf="submitted && !geometry" class="invalid-feedback d-block">

            {{ shapeMode === 'pin' ? t('Please place a pin on the map.') : t('Please draw a boundary on the map.') }}

          </div>

        </c-col>

      </c-row>



    </form>

  </c-card-body>

</c-card>

